var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownIconRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.300706 0.800598C0.69123 0.410074 1.3244 0.410074 1.71492 0.800598L5.99962 5.08574L10.2882 0.796677C10.6787 0.406153 11.3119 0.406153 11.7024 0.796677C12.093 1.1872 12.093 1.82037 11.7024 2.21089L6.70673 7.20706C6.31621 7.59758 5.68304 7.59758 5.29252 7.20706L0.300706 2.21481C-0.0898186 1.82429 -0.0898186 1.19112 0.300706 0.800598Z",
    fill: "#EE1B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIconRed);
export default __webpack_public_path__ + "static/media/downIconRed.1da078d18fc8700740ed8c89e56b6745.svg";
export { ForwardRef as ReactComponent };